/**
 * WP1 — wording for a result whose figures may omit trust property (engine breakdown.trust_estate_inclusion_gap).
 * Shared by the on-screen ReportBody (wizard, print, pro) and the downloadable report so both say the same thing.
 * Presentation only: the figures are the engine's, unchanged.
 */
export const TRUST_ESTATE_PROVISIONAL = 'This result is provisional because trust property may not be included.';
export const TRUST_ESTATE_PROVISIONAL_SHORT = 'Provisional: trust property may not be included.';
export const TRUST_ESTATE_ZERO_TAX = 'No inheritance tax is calculated from the information currently entered.';
